import { getNodeData } from "./nodeDataHelpers";

export function getDsName(node) {
    return getNodeData(node, 'fvDs');
}

